import { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
// react-router-dom components
import { Link } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";

// Material Dashboard 3 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import CoverLayout from "layouts/authentication/components/CoverLayout";

// Images
import bgImage from "assets/images/bg-sign-in-cover.jpeg";

import MongoHandler from "services/mongoHandler";
import TokenFunctions from "functions/tokenFunctions";

function SimpleCover() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState("");

    const mongoHandler = new MongoHandler();
    const tokenFunctions = new TokenFunctions();
    const navigate = useNavigate();

    const isEmailValid = (email) => {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };
  
    const onPageLoad = async () => {
        try {
            const valid = await tokenFunctions.refreshToken();
            if (valid) {
                navigate('/dashboards/ratings');
            }
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        onPageLoad();
    }, []);

    const login = async () => {
        if (!username || !password) {
            setErrorMessage("Bitte alle Felder ausfüllen.");
            return;
        }

        if (!isEmailValid(username)) {
            setErrorMessage("Bitte eine gültige Email-Adresse eingeben.");
            return;
        }

        const loginBody = {
            "usermail": `${username}`,
            "password": `${password}`,
        };

        try {
            const response = await mongoHandler.login(loginBody);
            if (response) {
                setErrorMessage(""); // Clear error message
            } else {
                setErrorMessage("Login war nicht erfolgreich. Bitte überprüfen Sie Ihre Eingaben.");
            }

            const valid = await tokenFunctions.checkAndSaveToken(response.token)

            if (valid) {
                navigate('/dashboards/ratings');
            }
            else {
                setErrorMessage("Session ist abgelaufen. Bitte erneut einloggen.");
            }

        } catch (e) {
            console.error(e);
            setErrorMessage("Ein Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.");
        }
    };

    return (
        <CoverLayout image={bgImage}>
            <Card>
                <MDBox
                    variant="gradient"
                    bgColor="info"
                    borderRadius="lg"
                    mx={2}
                    mt={2}
                    p={3}
                    mb={1}
                    textAlign="center"
                >
                    <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
                        Einloggen
                    </MDTypography>
                    <MDTypography display="block" variant="button" color="white" my={1}>
                        Zum Einloggen Email und Passwort eingeben
                    </MDTypography>
                </MDBox>
                <MDBox pt={4} pb={3} px={3}>
                    <MDBox component="form" role="form">
                        <MDBox mb={2}>
                            <MDInput
                                type="email"
                                label="Email"
                                variant="standard"
                                fullWidth
                                placeholder="john@example.com"
                                InputLabelProps={{ shrink: true }}
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                            />
                        </MDBox>
                        <MDBox mb={2}>
                            <MDInput
                                type="password"
                                label="Passwort"
                                variant="standard"
                                fullWidth
                                placeholder="************"
                                InputLabelProps={{ shrink: true }}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </MDBox>
                        {errorMessage && (
                            <MDBox mb={2}>
                                <MDTypography variant="button" color="error">
                                    {errorMessage}
                                </MDTypography>
                            </MDBox>
                        )}
                        <MDBox mt={4} mb={1}>
                            <MDButton
                                variant="gradient"
                                color="info"
                                fullWidth
                                onClick={login}
                            >
                                Login
                            </MDButton>
                        </MDBox>
                    </MDBox>
                </MDBox>
            </Card>
        </CoverLayout>
    );
}

export default SimpleCover;